import * as Sentry from "@sentry/react";

import ErrorFallback from "@components/common/ErrorFallback";
import { Navigate, useLocation } from "react-router-dom";

const PublicRoute = ({ component: Component, restricted, ...rest }) => {
  const { pathname } = useLocation();

  return restricted ? (
    <Navigate to="/login" />
  ) : (
    <Sentry.ErrorBoundary
      key={pathname}
      fallback={({ resetError }) => <ErrorFallback resetError={resetError} />}
    >
      <Component {...rest} />
    </Sentry.ErrorBoundary>
  );
};

export default PublicRoute;
